export const COMPARISON_CONSTANTS_OBSERVABILITY = {
  title: "Beyond Monitoring: Traditional vs OneMind Observability",
  desc: "Traditional tools react after something breaks. OneMind helps you predict, detect, and resolve issues before they ever impact your users.",
  items: [
    {
      title: "The Old Way",
      subTitle: "Traditional Monitoring Tools",
      points: [
        "Manual log reviews and siloed alert tools",
        "No real-time analysis — delays in incident detection",
        "Limited to on-prem or single-cloud visibility",
        "High noise from non-contextual alerts",
        "Reactive troubleshooting with no trend intelligence",
        "No built-in compliance or security integrations",
      ],
    },
    {
      title: "The New Way",
      subTitle: "OneMind Observability & NMS",
      points: [
        "Real-time insights from every layer — logs, metrics, and behaviors",
        "AI-powered anomaly detection and automated alerts",
        "Unified visibility across cloud, hybrid, and distributed environments",
        "Contextual alerting with root cause correlation",
        "Proactive performance optimization and incident prevention",
        "Compliance-ready with built-in frameworks for SOC 2, GDPR, CCPA, and PCI DSS",
      ],
    },
  ],
};
